import React, {Component} from 'react';
import {Row,Col,Modal,Form} from 'react-bootstrap';
import {LoginContainer, SubmitBtn} from '../../theme/MorsTheme';
import {login, forgotPassword} from '../../Utilities/WSUtil';
import {ACCESS_TOKEN,USERDATA}from '../../resources/constant.js';
import Link from 'react-router-dom/Link';
import renderHTML from 'react-render-html';
import {FaExclamationCircle} from 'react-icons/fa';
import '../../bdo.css';
import {css} from '@emotion/core';
import {BarLoader} from 'react-spinners';


const override = css`
display: block;
margin: 0 auto;
border-color: red;`;

class Login extends Component {

    constructor(props) {
        super(props);              
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.changePassword = this.changePassword.bind(this);
        this.forgotPasswordSubmit = this.forgotPasswordSubmit.bind(this);

        this.setUserData = this.setUserData.bind(this);

        this.state = {
            show: false,
            changePassword: 'Change Password',            
            fetchMessage: '',
            loginValidated: false,
            forgotPasswordValidated: false,
            forgotPasswordResponse: '',
            forgotPasswordStatus:false,
            showExclamation:false,
            userName:'',
            password:'',
            userId:'',
            userData:[],
            showExp:true,
            loading:true,   
            errorMsg:true           
          };   
    }
    

    componentDidMount(){
        this.setState({fetchMessage:'',showExclamation:false,forgotPasswordResponse:''})        
    }

    changePassword(){

    }

    handleClose(event) {
        event.preventDefault();      
        this.setState({ show: false,
            forgotPasswordValidated: false,
            forgotPasswordResponse: '',
            forgotPasswordStatus:false,
            showExclamation:false
        });        
      }

    handleShow(event){       
        event.preventDefault();       
        this.setState({ show: true, userId:'' });         
    }
    
    handleChange(e){                        
        this.setState(
            {                
                [e.target.id]: e.target.value
            }
        )
    }

    setUserData(){        
        this.props.setUserData(this.state.userData);

    }


    forgotPasswordSubmit(event) {        
        event.preventDefault();                         
        event.stopPropagation();
        
        this.setState({ show: true, forgotPasswordResponse:'', 
        forgotPasswordStatus:false,showExclamation:false});        
        
        forgotPassword(this.state.userId)
        .then(response =>                        
            {                        
            this.setState({
                forgotPasswordResponse:response.message,
                forgotPasswordStatus:response.success,
            })                               
        }
        ).catch(error =>{                                  
            this.setState({
                forgotPasswordResponse: error.message,  
                forgotPasswordStatus: error.success,
                showExclamation: error.showSign
                            
        })            
        })         
    }

    handleSubmit(event) {        
        event.preventDefault();                  
        event.stopPropagation();       

        
        if(this.state.userName===''){
            this.setState({fetchMessage:'Please enter a user name.'})
        }else if(this.state.password===''){
            this.setState({fetchMessage:'Please enter a password.'})
        }else{
            this.setState({loading: false});
            this.setState({errorMsg:true});
            login(this.state.userName, this.state.password)                    
            .then(response => {                     
                localStorage.setItem(ACCESS_TOKEN, response.jwt.accessToken); 
                localStorage.setItem(USERDATA, JSON.stringify(response.user));                                         
                this.props.onLogin(response);                              
                this.setState({loading: true});
            }).catch(error =>{            
                this.setState({errorMsg:false});
                this.setState({loading:true});
                if(error.success){                    
                    localStorage.setItem(ACCESS_TOKEN, error.jwt.accessToken);
                    localStorage.setItem(USERDATA, JSON.stringify(error.user));                                          
                    this.setState({
                        showExp: false,
                        userData: JSON.stringify(error.user),                                           
                    });
                }
                
                this.setState({
                    fetchMessage: error.message,                    
                }) 
                
                this.props.setInvalidAttempt(error.attemp, error.lastLogin);
            }
            ) 
        }                       
    }
    render() { 
       return(      
        <div>
        <LoginContainer> 
            <div style={{padding:'20px 0px 20px 10px'}}><span style={{fontSize:'18px', color:'#FFB20C', fontWeight:'bold'}}>Login</span></div>
            <Form onSubmit={this.handleSubmit} style={{color:'white'}}>
                <Form.Group className='loginFormGroup' as={Col} controlId="userName"  onChange={this.handleChange}>
                    <Form.Label className='loginFormLabel' >User ID</Form.Label>
                    <Form.Control  style={{height:'26px',width:'100%'}}  autoFocus={true} size='sm' maxLength={10} type="text" defaultValue={this.state.userName}></Form.Control>                    
                </Form.Group>

                <Form.Group className='loginFormGroup' as={Col} controlId="password" onChange={this.handleChange}>
                    <Form.Label className='loginFormLabel'> Password</Form.Label>
                    <Form.Control style={{height:'26px',width:'100%'}} size='sm' type='password' maxLength={15} defaultValue={this.state.password}></Form.Control>                    
                </Form.Group>                
                <div align={'right'}>
                    <SubmitBtn>LOGIN</SubmitBtn>                                        
                </div>   

                <div style={{padding: '0px 0px 0px 10px'}}>
                    <Link to='/' onClick={this.handleShow}>
                        <span style={{color:'white', fontSize:'12px'}}>
                        Forgot your password?
                        </span>
                    </Link>
                </div>                                         
            </Form>

                       
            <Modal show={this.state.show} backdrop={'static'}  onHide={this.handleClose} centered={true} backdropClassName='fade'>                
                    <Modal.Header style={{backgroundColor:'#0B2972', heightc16:'40px', padding:'15px, 0px'}}>                      
                        <Modal.Title style={{fontSize:'14px', color:'white'}}><span>Forgot Password</span></Modal.Title>
                    </Modal.Header>
                    <Modal.Body >    
                        
                    <Form onSubmit={this.forgotPasswordSubmit}>         
                        <div align="center" style={{fontSize:'14px', paddingBottom:'10px'}} hidden={this.state.forgotPasswordStatus}>Enter Required Information</div>                                                
                        <Form.Group as={Row} controlId="userId" onChange={this.handleChange} hidden={this.state.forgotPasswordStatus}>
                            <Form.Label column sm="3" style={{fontWeight:'bold'}}>User ID</Form.Label>                                                
                            <Col sm="8">
                                <Form.Control style={{height:'26px', width:'300px'}} type="text" maxLength={10} value={this.state.userId}></Form.Control>                                
                            </Col>
                        </Form.Group>  
               
                        <div align="center" style={{color:(this.state.forgotPasswordStatus? 'black':'red'), marginTop:'10px',fontSize:'12px'}}>                            
                            <span style={{fontSize:'16px', paddingRight:'10px'}}> 
                            {this.state.showExclamation? <FaExclamationCircle/> : ''}</span>
                            <span>{renderHTML(this.state.forgotPasswordResponse)}</span>

                        </div>                                         
                        <div align="center" style={{marginTop:'10px'}}>    
                            <SubmitBtn onClick={this.handleClose}>Back</SubmitBtn>                                         
                            <SubmitBtn hidden={this.state.forgotPasswordStatus}>Submit</SubmitBtn>                                                                    
                        </div>                                         
                        </Form>
                    </Modal.Body>                                                               
            </Modal>            
            
        </LoginContainer>  


        <div style={{color:'red', marginTop:'12px',  fontSize:'14px'}} hidden={this.state.errorMsg}>        
           {renderHTML(this.state.fetchMessage)}    
        </div> 

        
        <div style={{padding: '0px'}} hidden={this.state.showExp}>
            <Link to='/chngExpPwd' onClick={() => this.setUserData()}>
                <span style={{color:'#244693', fontSize:'11px', fontWeight:'bold'}}>
                Change your password now?
                </span>
            </Link>
        </div>      

        
        <Row as={Col} noGutters hidden={this.state.loading}>
                 <Col>
                 Validating please wait...
                 </Col>
                 <Col>
                 <div className='sweet-loading' style={{paddingTop:'7px'}}>
                 <BarLoader
                    css={override}
                    sizeUnit={"px"}
                    size = {10}
                    height={8}
                    width={150}
                    color={'#0B2972'}
                    
                 />
                </div>
                 </Col>        
        </Row>        
    </div>        
        )                
    }
}

export default Login;